<input name="numberInput" class="numberAlign form-control" [ngModel]="value"
    (ngModelChange)="value = toNumber($event); update();" [placeholder]="placeholder" [disabled]="disabled" #inputRef
    [textMask]="{mask: mask, guide:false}" golAutoSelect golForceDecimals>